import {
  SHOW_ERRORS_MODAL,
  HIDE_ERRORS_MODAL,
  SET_ERRORS_MODAL_INFO,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    listErrors: [],
    isVisibleErrorsModal: false,
  },
  mutations: {
    [SHOW_ERRORS_MODAL](state) {
      state.isVisibleErrorsModal = true;
    },
    [HIDE_ERRORS_MODAL](state) {
      state.isVisibleErrorsModal = false;
    },
    [SET_ERRORS_MODAL_INFO](state, errors) {
      state.listErrors = errors.length > 0 ? errors : null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/errors.js